import { render, staticRenderFns } from "./ReviewsIndicatorsList.vue?vue&type=template&id=5f53daa8&scoped=true&"
import script from "./ReviewsIndicatorsList.vue?vue&type=script&lang=js&"
export * from "./ReviewsIndicatorsList.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsIndicatorsList.vue?vue&type=style&index=0&id=5f53daa8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f53daa8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
